import { MenuShelfConfigurationEntry } from './menu-shelf-configuration-entry';

export interface MenuShelfConfigurationProps {
	readonly toggleBackVisibility: () => void;
	readonly toggleDoorVisibility: () => void;
	readonly toggleShelfVisibility: () => void;
	readonly toggleCrossDivider: () => void;
	readonly toggleCornerDirection: () => void;
	readonly toggleTopDrawerVisibility: () => void;
	readonly toggleMiddleDrawerVisibility: () => void;
	readonly toggleBottomDrawerVisibility: () => void;
	readonly deleteShelf: () => void;
}

export const MenuShelfConfiguration = (props: MenuShelfConfigurationProps) => {
	return (
			<div className="p-4">
				<div className="mt-4">
					<fieldset>
						<div className="space-y-1">
							<label className="relative block rounded-lg border border-gray-300 bg-white shadow-sm px-4 py-4 cursor-pointer hover:border-gray-400 sm:justify-between focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500 sm:flex style-info">
								<span>Drag a box to rearrange your layout. Click a box to add drawers, doors, shelves, or a back.</span>
							</label>
						</div>
					</fieldset>
				</div>
				<div>
					<fieldset>
						<legend className="sr-only">Options</legend>
						<div className="space-y-1">
							<MenuShelfConfigurationEntry additionalClass="style-button-back" shelfPart="Back" handleClick={() => props.toggleBackVisibility()} />
							<MenuShelfConfigurationEntry additionalClass="style-button-door" shelfPart="Door" handleClick={() => props.toggleDoorVisibility()} />
							<MenuShelfConfigurationEntry additionalClass="style-button-shelves" shelfPart="Shelves" handleClick={() => props.toggleShelfVisibility()} />
							<MenuShelfConfigurationEntry additionalClass="style-button-cross-divider" shelfPart="Cross Divider" handleClick={() => props.toggleCrossDivider()} />
						</div>
					</fieldset>
				</div>

				<div className="mt-4" id="box-corner">
					<fieldset>
						<legend className="sr-only">Corner</legend>
						<div className="space-y-1">
							<MenuShelfConfigurationEntry additionalClass="style-button-corner" shelfPart="Corner direction" handleClick={() => props.toggleCornerDirection()} />
						</div>
					</fieldset>
				</div>

				<div className="mt-4">
					<fieldset>
						<legend className="sr-only">Drawers</legend>
						<div className="space-y-1">
							<MenuShelfConfigurationEntry additionalClass="style-button-top-drawer" shelfPart="Top Drawer" handleClick={() => props.toggleTopDrawerVisibility()} />
							<MenuShelfConfigurationEntry additionalClass="style-button-middle-drawer" shelfPart="Middle Drawer" handleClick={() => props.toggleMiddleDrawerVisibility()} />
							<MenuShelfConfigurationEntry additionalClass="style-button-bottom-drawer" shelfPart="Bottom Drawer" handleClick={() => props.toggleBottomDrawerVisibility()} />
						</div>
					</fieldset>
				</div>

				<div className="mt-4">
					<fieldset>
						<div className="space-y-1">
							<MenuShelfConfigurationEntry additionalClass="style-button-delete" shelfPart="Delete" handleClick={() => props.deleteShelf()} />
						</div>
					</fieldset>
				</div>

				<div className="mt-4">
					<fieldset>
						<div className="space-y-1">
							<label className="relative block rounded-lg border border-gray-300 bg-white shadow-sm px-4 py-4 cursor-pointer hover:border-gray-400 sm:justify-between focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500 hidden style-cube-info">
								<span>Drawers, doors, and shelves are sold in pairs.</span>
							</label>
						</div>
					</fieldset>
				</div>
			</div>
	);
};
